module.exports = __webpack_public_path__ + "zjfd-icon.png?ce80cf07b47be7b2bdf88051766d5196";


//////////////////
// WEBPACK FOOTER
// ./static/assets/zjfd-icon.png
// module id = 41
// module chunks = 0